// Skill sets on /resume. `print: false` keeps an item on the page but out of
// the two-page PDF (see sections/Skills.js).
const S = (name, print = true) => ({ name, print })
const web = name => S(name, false)

export default {
  ai: [
    S('Claude Code'),
    S('Codex'),
    S('Agent Skills and hooks'),
    S('Model Context Protocol (MCP)'),
    S('OpenAI API'),
    web('Agent drivers'),
    S('Tool-call orchestration'),
    web('Multi-agent workflows'),
    S('Prompt and context engineering'),
    S('LLM-as-judge'),
    S('Evals'),
    S('RAG'),
    web('Embeddings'),
    S('pgvector'),
    S('Guardrails'),
    web('Streaming agent UIs'),
    web('Cursor')
  ],
  web: [
    S('React'),
    S('TypeScript'),
    S('JavaScript'),
    S('Next.js'),
    S('Node.js'),
    S('HTML'),
    S('CSS'),
    S('Responsive design'),
    S('Accessibility (WCAG 2.2 AA)'),
    S('Storybook'),
    S('React Native'),
    web('Electron'),
    web('Web Components'),
    web('Zod'),
    web('i18n'),
    web('SEO and structured data'),
    web('Tailwind CSS'),
    web('Radix'),
    web('Webpack'),
    web('Redux')
  ],
  data: [
    S('REST'),
    web('OpenAPI / Swagger'),
    S('WebSockets'),
    S('Server-Sent Events'),
    S('Express.js'),
    S('SQL'),
    S('PostgreSQL (partitioning, tuning)'),
    web('Drizzle'),
    web('Supabase'),
    web('Citus'),
    S('MongoDB'),
    S('Redis'),
    S('OAuth 2.0'),
    web('JWT'),
    web('Auth0'),
    web('Stripe'),
    web('Paddle'),
    web('IMAP and SMTP')
  ],
  windows: [
    S('C#'),
    S('.NET'),
    S('ASP.NET Core'),
    S('Entity Framework'),
    web('LINQ'),
    web('SignalR'),
    S('MS SQL'),
    web('XAML'),
    web('MVVM'),
    web('Windows Phone')
  ],
  testing: [
    S('Playwright'),
    S('Jest'),
    web('react-testing-library'),
    web('Node.js test runner'),
    S('Visual regression testing'),
    S('axe (accessibility)'),
    S('Checkly'),
    S('End-to-end testing'),
    S('Code review')
  ],
  tools: [
    S('Cloudflare Workers'),
    S('R2'),
    S('D1'),
    web('Queues'),
    web('Turnstile'),
    S('Vercel'),
    S('Docker'),
    web('Docker Compose'),
    web('nginx'),
    web('Git'),
    S('GitHub Actions'),
    S('CI/CD'),
    S('PostHog'),
    web('Datadog'),
    web('Sentry'),
    web('Biome'),
    S('OWASP ASVS'),
    S('CASA Tier 2'),
    S('Security audits'),
    S('Production-readiness audits'),
    web('GEO / AI-search visibility'),
    web('Email deliverability (SPF, DKIM, DMARC)'),
    web('Rate limiting'),
    web('Jira')
  ],
  soft: [
    S('Technical leadership'),
    S('Mentorship'),
    S('Pair programming'),
    S('Scrum Master'),
    S('Hiring and interviews'),
    S('Pre-sales and estimation'),
    web('Product thinking')
  ]
}
